import React, { useState, createRef, useEffect, useContext } from 'react';
import {BsChevronLeft, BsChevronRight} from "react-icons/bs";
import Button from './Button';
import './Banner.css';
import axiosInstance from '../axiosInstance';
import { ModalContext } from '../context/ModalContext';

const Banner = () => {
    const modalContext = useContext(ModalContext);
    const [bannerData, setBannerData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axiosInstance.get("/api/getbanners"); // Adjust port if needed
                const fetchedData = Array.isArray(res.data) ? res.data : []; // Assuming data is an array
                setBannerData(fetchedData);
            } catch (err) {
                console.error("Error fetching data:", err);
                setBannerData([]); // fallback
            }
        };
        fetchData();
    }, []);

    // We will start by storing the index of the current image in the state.
    const [index, setIndex] = useState(0);
  
    // We are using react ref to 'tag' each of the images. Below will create an array of
    // objects with numbered keys. We will use those numbers (i) later to access a ref of a
    // specific image in this array.
    const refs = Array.isArray(bannerData)
    ? bannerData.reduce((acc, _, i) => {
        acc[i] = createRef();
        return acc;
      }, {})
    : {};

    // Some validation for checking the array length could be added if needed
    useEffect(() => {
        if (!bannerData.length) return;

        const totalImages = bannerData.length;
        const lastIndex = totalImages - 1;
        
        if (index < 0) {
          setIndex(lastIndex);
        }
        if (index > lastIndex) {
          setIndex(0);
        }
      }, [index, bannerData]);
    
      // autoslide, clearInterval = een cleanup functie noodzakelijk bij interval
      useEffect(() => {
        if (!bannerData.length) return;

        let slider = setInterval(() => {
          setIndex((prev) => prev + 1);
        }, 109000);
        return () => clearInterval(slider);
      }, [bannerData]);
    // Below functions will assure that after last image we'll scroll back to the start,
    // or another way round - first to last in previousImage method.
    const nextImage = () => {
        setIndex((prev) => prev + 1)
    };

    const previousImage = () => {
        setIndex((prev) => prev - 1)
    };

    // Tailwind styles. Most importantly notice position absolute, this will sit relative to the carousel's outer div.
    const arrowStyle = "absolute bottom-0.5 text-slate-600 text-2xl z-10 bg-slate-300 h-9 w-9 opacity-75 flex items-center justify-center hover:bg-orange-600 hover:text-white rounded-md";

    // Let's create dynamic buttons. It can be either left or right. Using
    // isLeft boolean we can determine which side we'll be rendering our button
    // as well as change its position and content.
    const sliderControl = isLeft => (
        <button type="button" onClick={isLeft ? previousImage : nextImage} className={`${arrowStyle} ${isLeft ? 'left-1/2 -ml-10' : 'right-1/2 -mr-10'}`}>
            <span role="img" aria-label={`Arrow ${isLeft} ? 'left' : 'right'`}>
                {isLeft ? <BsChevronLeft/> : <BsChevronRight/>}
            </span>
        </button>
    );

    return(
        <div className="w-full h-screen overflow-hidden flex justify-center home-banner">
            <div className="relative w-full">                
                <div className="overflow-hidden snap-x inline-flex relative w-full h-full">
                    {sliderControl(true)}
                    {bannerData.length > 0 ? (
                        bannerData.map((item,i)=>{    
                        let position = "opacity-0";                        
                        if (i === index) {
                          position = "opacity-100 active";
                        }
                        if (
                          i === index - 1 ||
                          (index === 0 && i === item.length - 1)
                        ) {
                          position = "opacity-0";
                        }
                        return (
                            <div className={`w-full h-full flex flex-shrink-0 absolute top-0 left-0 items-center transition-all duration-1000 delay-300 ${position}`} key={item.id} ref={refs[i]}>
                            <div className={`absolute w-full h-full bg-no-repeat bg-cover bg-center z-0 top-0 left-0 banner-img ${i === index ? 'active' : ''}`} style={{backgroundImage:`url(${item.imagePath})`}}></div>
                            {/* <div className='w-full h-full flex absolute bottom-0 left-0 bg-slate-950 bg-opacity-35 z-1'></div> */}
                            {(item.captionheading || item.captiontext) && (
                            <div className='container mx-auto my-auto relative z-10'>
                                <div className={`w-full md:w-3/5 caption animated-border transition-all duration-700 ease-in-out rounded-tr-3xl rounded-bl-3xl `}>
                                    <span className="border-top"></span>
                                    <span className="border-right"></span>
                                    <span className="border-bottom"></span>
                                    <span className="border-left"></span>
                                    <div className='text-slate-900 flex flex-col justify-start relative z-30 gap-3 px-5 py-5'>
                                        {item.captionheading && (
                                        <div className='flex heading text-xl md:text-5xl font-bold leading-tight px-4 py-0 pb-0  [text-shadow:_0_2px_6px_rgb(255_255_255_/_0.8)]'>{item.captionheading}</div>
                                        )}
                                        {item.captiontext && (
                                        <div className='flex subtext text-base font-medium md:text-xl px-4 py-2 [text-shadow:_0_1px_3px_rgb(255_255_255_/_0.8)]'>{item.captiontext}</div>
                                        )}
                                        <div className='buttons grid grid-flow-col auto-cols-max gap-2 px-4 py-2 justify-start'>
                                        <Button type='button' variant='secondary' className='font-normal rounded hover:bg-sky-950 hover:border-transparent hover:text-white'>See Project</Button>
                                        <Button type='button' variant='primary' className='font-normal rounded hover:bg-sky-950 hover:border-transparent hover:text-white'  onClick={() => {
                                            modalContext.setShowEnquiryPopup(true);
                                        }}>Request a quote</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                    )}
                    )) : (
                        <p className="text-center p-4">No banners available</p>
                    )}
                    {sliderControl()}
                </div>
            </div>
        </div>
    );
}

export default Banner;